import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from '../lib/api';
import Moment from 'moment';
var MESSAGES_PER_PAGE = 50;
export var GET_CONVERSATIONS = 'CONVERSATIONS_GET_CONVERSATIONS';
export var GET_CONVERSATION = 'CONVERSATIONS_GET_CONVERSATION';
export var GET_CONVERSATIONS_REFERENCE = 'CONVERSATIONS_GET_CONVERSATIONS_BY_REFERENCE';
export var RESET_CONVERSATION = 'CONVERSATIONS_RESET_CONVERSATION';
export var GET_CONVERSATION_MESSAGES = 'CONVERSATION_GET_CONVERSATION_MESSAGES';
export var GET_USER_CONTACTS = 'CONVERSATION_GET_USER_CONTACTS';
export var GET_UNREAD_COUNT = 'CONVERSATION_GET_USER_UNREAD_COUNT';
export var SEARCH_CONVERSATIONS = 'CONVERSATION_SEARCH_CONVERSATIONS';
export var CLEAR_SEARCH_CONVERSATIONS = 'CONVERSATION_CLEAR_SEARCH_CONVERSATIONS';
export var FLAG_MESSAGE = 'CONVERSATION_FLAG_MESSAGE';
export var STAGE_CONVERSATION = 'CONVERSATION_STAGE_NEW_CONVERSATION';
export var SUBMIT_CONVERSATION = 'CONVERSATION_SUBMIT_NEW_CONVERSATION';
export var SUBMIT_CONVERSATION_MESSAGE = 'CONVERSATION_SUBMIT_CONVERSATION_MESSAGE';
export var SUBMIT_CONVERSATION_FILE = 'CONVERSATION_SUBMIT_CONVERSATION_FILE';
export var GET_STUDENT_GUARDIANS = 'CONVERSATION_GET_STUDENT_GUARDIANS';
export var ADD_CONVERSATION_MEMBER = 'CONVERSATION_ADD_MEMBER';
export var REMOVE_CONVERSATION_MEMBER = 'CONVERSATION_REMOVE_MEMBER';
export var getConversations = function getConversations(studentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var response, sortItems;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return api.get("conversations");
          case 1:
            response = _context.sent;
            sortItems = function sortItems(a, b) {
              if (a.messages.length > 0 && b.messages.length > 0) return Moment(b.messages[0].created).unix() - Moment(a.messages[0].created).unix();else return 0;
            };
            response.data.sort(sortItems);
            dispatch({
              type: GET_CONVERSATIONS,
              payload: response.data
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getConversation = function getConversation(id) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return api.get("conversations/".concat(id));
          case 1:
            response = _context2.sent;
            dispatch({
              type: GET_CONVERSATION,
              payload: response.data
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getConversationsByReference = function getConversationsByReference(referenceId, referenceType, student) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return api.get("conversations?referenceId=".concat(referenceId, "&referenceType=").concat(referenceType));
          case 1:
            response = _context3.sent;
            dispatch({
              type: GET_CONVERSATIONS_REFERENCE,
              payload: response.data
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var getMessages = function getMessages(conversation, page) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var skip, top, response;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            skip = page * MESSAGES_PER_PAGE;
            top = skip + MESSAGES_PER_PAGE;
            _context4.next = 1;
            return api.get("conversations/".concat(conversation, "/messages?skip=").concat(skip, "&top=").concat(top));
          case 1:
            response = _context4.sent;
            dispatch({
              type: GET_CONVERSATION_MESSAGES,
              payload: response.data
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var submitMessage = function submitMessage(message) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var data, response;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            data = JSON.stringify(message);
            _context5.next = 1;
            return api.post('conversations/message', data);
          case 1:
            response = _context5.sent;
            dispatch({
              type: SUBMIT_CONVERSATION_MESSAGE,
              payload: _objectSpread(_objectSpread({}, message), {}, {
                id: response.data
              })
            });
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var submitConversationFile = function submitConversationFile(conversationId, file) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 1;
            return api.postFile("conversations/".concat(conversationId, "/files"), file);
          case 1:
            response = _context6.sent;
            dispatch({
              type: SUBMIT_CONVERSATION_FILE,
              payload: response.data
            });
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var resetConversation = function resetConversation() {
  return {
    type: RESET_CONVERSATION,
    payload: true
  };
};
export var createConversation = function createConversation(conversation, studentId) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var conversationPayload, data, response;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            conversationPayload = _objectSpread({}, conversation);
            if (conversationPayload.id != null) {
              delete conversationPayload.id;
            }
            data = JSON.stringify(conversationPayload);
            _context7.next = 1;
            return api.post("conversations", data);
          case 1:
            response = _context7.sent;
            dispatch({
              type: SUBMIT_CONVERSATION,
              payload: response.data
            });
            return _context7.abrupt("return", response.data);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var stageConversation = function stageConversation(conversation) {
  return function (dispatch) {
    dispatch({
      type: STAGE_CONVERSATION,
      payload: conversation
    });
  };
};
export var getContacts = function getContacts(student) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 1;
            return api.get("conversations/contacts/".concat(student));
          case 1:
            response = _context8.sent;
            dispatch({
              type: GET_USER_CONTACTS,
              payload: response.data
            });
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var getUnreadMessages = function getUnreadMessages(studentId) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 1;
            return api.get("conversations/unread");
          case 1:
            response = _context9.sent;
            dispatch({
              type: GET_UNREAD_COUNT,
              payload: response.data
            });
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var searchConversation = function searchConversation(query, studentId) {
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(dispatch) {
      var response;
      return _regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            _context0.next = 1;
            return api.get("conversations/?search=".concat(query));
          case 1:
            response = _context0.sent;
            dispatch({
              type: SEARCH_CONVERSATIONS,
              payload: response.data
            });
          case 2:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return function (_x0) {
      return _ref0.apply(this, arguments);
    };
  }();
};
export var clearSearch = function clearSearch() {
  return {
    type: CLEAR_SEARCH_CONVERSATIONS,
    payload: true
  };
};
export var flagMessage = function flagMessage(id, reason) {
  return /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(dispatch) {
      var values, response;
      return _regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            values = {
              'messageId': id,
              'reason': reason
            };
            _context1.next = 1;
            return api.post("conversations/flagged", values);
          case 1:
            response = _context1.sent;
            dispatch({
              type: FLAG_MESSAGE,
              payload: _objectSpread({
                flagID: response.data
              }, values)
            });
          case 2:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    return function (_x1) {
      return _ref1.apply(this, arguments);
    };
  }();
};
export var getStudentGuardians = function getStudentGuardians(studentId) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch, getState) {
      var state, response;
      return _regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            state = getState(); // Kontrollera om vi redan har lastat guardians för denna student
            if (!(state.Conversation.studentGuardiansLoadedForStudentId === studentId)) {
              _context10.next = 1;
              break;
            }
            return _context10.abrupt("return", Promise.resolve());
          case 1:
            _context10.next = 2;
            return api.get("students/".concat(studentId));
          case 2:
            response = _context10.sent;
            dispatch({
              type: GET_STUDENT_GUARDIANS,
              payload: {
                studentId: studentId,
                guardians: response.data.guardians || []
              }
            });
          case 3:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x10, _x11) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export var addConversationMember = function addConversationMember(membership) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch) {
      var data, response;
      return _regeneratorRuntime.wrap(function (_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            data = JSON.stringify(membership);
            _context11.next = 1;
            return api.post('conversations/membership', data);
          case 1:
            response = _context11.sent;
            dispatch({
              type: ADD_CONVERSATION_MEMBER,
              payload: _objectSpread(_objectSpread({}, membership), {}, {
                id: response.data
              })
            });
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function (_x12) {
      return _ref11.apply(this, arguments);
    };
  }();
};
export var removeConversationMember = function removeConversationMember(membershipId, membershipID) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(dispatch) {
      return _regeneratorRuntime.wrap(function (_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 1;
            return api["delete"]("conversations/membership/".concat(membershipId));
          case 1:
            dispatch({
              type: REMOVE_CONVERSATION_MEMBER,
              payload: {
                id: membershipId,
                membershipID: membershipID
              }
            });
          case 2:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x13) {
      return _ref12.apply(this, arguments);
    };
  }();
};